module.exports = __webpack_public_path__ + "img/document-icon-dark.44465262.svg";